import { createStore } from "vuex";
import general from "./modules/general.js";
import auth from "./modules/auth.js";
import notifications from "./modules/notifications.js";
import feedback from "./modules/feedback.js";

const debug = process.env.NODE_ENV !== "production";

export default createStore({
	modules: {
		general,
		auth,
		notifications,
		feedback,
	},
	strict: debug,
	plugins: [],
});
